import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";

import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { capitalizeFirstLetterOfEachWord } from "../../../Components/Functions/word.fun";
import PriceWatcheLineChart from "../Price watcher components/price_watcher_linechart";
import { format } from "date-fns";
import { FcSalesPerformance } from "react-icons/fc";
import PriceWatcherViewTable from "./price_watcher_view_table";
import Pagination from "../../../Components/layouts/pagination";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { RotatingLines } from "react-loader-spinner";

const ViewPriceWatcher = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [chartData, setChartData] = useState();
  const [chartPage, setChartPageData] = useState();
  const [chartDataFuture, setChartDataFu] = useState();
  let { id } = useParams();
  const [dataFrom, setDataFrom] = useState(3);
  const [agro, setAgro] = useState();
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [loader, setLoader] = useState(true);

  const navigate = useNavigate();

  function calculateDiscountedPrice(originalPrice, discount) {
    const discountedPrice = originalPrice * (1 - discount);
    return discountedPrice;
  }
  const formatDate = (dateStr) => format(new Date(dateStr), "dd MMMM yyyy");

  const hadndleResearch = () => {
    navigate("/buyers-price-watcher/research");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await performRequest(
          "GET",
          `/priceWatcher/getPriceWatcherById/${id}`
        );

        if (res.status === 200) {
          setData(res.data);

          const chartRes = await performRequest(
            "GET",
            `/priceWatcher/getLineChartdata?plantId=${res.data.plantId}&page=${page}`
          );

          if (chartRes.status === 200) {
            setChartData(chartRes?.data?.priceWatcherData);
            setChartPageData(chartRes?.data?.priceWatcherPageData);
            setTotalPages(
              Math.ceil(chartRes?.data?.priceWatcherDataCount / 50)
            );
            setLoading(false);

            const chartfures = await performRequest(
              "GET",
              `/priceWatcher/getFutureLineChartdata?plantId=${res.data.plantId}`
            );

            if (chartfures.status === 200) {
              setChartDataFu(chartfures.data);
            } else {
              Toast("error", "Error while getting future chart data!");
            }
          } else {
            Toast("error", "Error while getting chart data!");
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      } catch (err) {
        CustomErrorResponse(err);
      }
    };

    fetchData();
  }, [refresh, page, id]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/priceWatcher/getAgronomyImage/")
      .then((res) => {
        if (res.status === 200) {
          setAgro(res.data?.agronomyWiki);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const SortedData = chartPage?.sort((a, b) => {
    if (a.createdAt > b.createdAt) return -1;
    if (a.createdAt < b.createdAt) return 1;
    return 0;
  });

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSalesPerformance className="fs-2  me-1" />
                  Price Watcher
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Track different commodities and there
                  pricing.
                </h4>
              </div>
              <div className="col-md-4"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 col-sm-12 py-2">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Specs.</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && (
                        <tr>
                          <td>Plant Name</td>
                          <td>{data?.plantName || "N/A"}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Week</td>
                          <td>
                            {capitalizeFirstLetterOfEachWord(data?.week) ||
                              "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Year</td>
                          <td>{data?.year || "N/A"}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Week start date</td>
                          <td>{formatDate(data?.weekStartDate) || "N/A"}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Week end date</td>
                          <td>{formatDate(data?.weekEndDate) || "N/A"}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Wholesale price</td>
                          <td>
                            ₹
                            {calculateDiscountedPrice(
                              data?.weeklyPrice,
                              0.35
                            )?.toFixed(2) || "N/A"}{" "}
                            - ₹
                            {calculateDiscountedPrice(
                              data?.weeklyPrice,
                              0.15
                            )?.toFixed(2) || "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Retail price</td>
                          <td>
                            ₹
                            {calculateDiscountedPrice(
                              data?.weeklyPrice,
                              0.05
                            )?.toFixed(2) || "N/A"}{" "}
                            - ₹{data?.weeklyPrice || "N/A"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card mt-3 border-0">
                <div className="card-body p-0">
                  <img
                    className="d-none d-sm-block"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752556072/1_vyhuj0_b1uh26_tcvj3t.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </div>
              <div className="card p-2 mb-3 mt-3 d-none d-sm-block">
                <h3 className="m-0 p-0">Disclaimer :</h3>
                <hr className="m-1" />
                <div className="p-1">
                  <p className="p-0 m-0">
                    The agricultural commodity price trends provided are for
                    informational purposes only and should not be considered as
                    financial or investment advice. This data is processed and
                    refined using AI and may not always reflect real-time market
                    conditions with complete accuracy. While we strive to
                    provide reliable insights, we do not guarantee the absolute
                    correctness of the information. Users are strongly advised
                    to conduct their own market research and consult with
                    industry professionals before making any financial or
                    business decisions. We are not liable for any losses or
                    consequences resulting from reliance on this data.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-sm-12 py-2">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div className="dropdown p-1">
                      <a
                        className="dropdown-toggle text-muted"
                        href="/"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {dataFrom === 6
                          ? `Last ${dataFrom} months`
                          : `Last ${dataFrom} year${dataFrom > 1 ? "s" : ""}`}
                      </a>

                      <div className="dropdown-menu dropdown-menu-end">
                        <span
                          onClick={() => setDataFrom(6)}
                          className="dropdown-item"
                        >
                          Last 6 months
                        </span>
                        <span
                          onClick={() => setDataFrom(1)}
                          className="dropdown-item"
                        >
                          Last 1 year
                        </span>
                        <span
                          onClick={() => setDataFrom(2)}
                          className="dropdown-item"
                        >
                          Last 2 year's
                        </span>
                        <span
                          onClick={() => setDataFrom(3)}
                          className="dropdown-item"
                        >
                          Last 3 year's
                        </span>
                      </div>
                    </div>
                    <div>
                      {loader ? (
                        <RotatingLines
                          visible={true}
                          height="35"
                          width="35"
                          color="grey"
                          strokeWidth="5"
                          animationDuration="0.75"
                          ariaLabel="rotating-lines-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <PriceWatcheLineChart
                    plantPriceData={chartData}
                    dataFrom={dataFrom}
                    chartDataFuture={chartDataFuture}
                    loader={loader}
                    setLoader={setLoader}
                  />
                </div>

                {
                  <PriceWatcherViewTable
                    data={SortedData}
                    agro={agro}
                    currentPage={page}
                    itemsPerPage={50}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                }
                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={SortedData?.length || 0}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton
                      buttonText="Research RNN"
                      onClick={hadndleResearch}
                    />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
              <div className="card mt-3 border-0">
                <div className="card-body p-0">
                  <img
                    className="d-block d-sm-none"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752556072/1_vyhuj0_b1uh26_tcvj3t.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </div>
              <div className="card p-2 mb-3 mt-3 d-block d-sm-none">
                <h3 className="m-0 p-0">Disclaimer :</h3>
                <hr className="m-1" />
                <div className="p-1">
                  <p className="p-0 m-0">
                    The agricultural commodity price trends provided are for
                    informational purposes only and should not be considered as
                    financial or investment advice. This data is processed and
                    refined using AI and may not always reflect real-time market
                    conditions with complete accuracy. While we strive to
                    provide reliable insights, we do not guarantee the absolute
                    correctness of the information. Users are strongly advised
                    to conduct their own market research and consult with
                    industry professionals before making any financial or
                    business decisions. We are not liable for any losses or
                    consequences resulting from reliance on this data.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewPriceWatcher;
